import { useEffect } from 'react';

// Create a single background audio element
const backgroundAudio = new Audio();
backgroundAudio.src = `/sound3.mp3`;
backgroundAudio.volume = 0.6;
backgroundAudio.loop = false; // Don't use built-in loop to handle restart properly

// Function to play audio and handle restart when it ends
const playBackgroundAudio = () => {
    backgroundAudio.play().catch(err => {
        console.log('Audio play error:', err);
    });

    // When audio ends, play it again
    backgroundAudio.onended = () => {
        // Small delay before replaying to avoid any potential issues
        setTimeout(() => {
            backgroundAudio.currentTime = 0;
            playBackgroundAudio();
        }, 100);
    };
};

// Try to initialize audio automatically
document.addEventListener('DOMContentLoaded', () => {
    // Function to initialize audio after user interaction
    const initAudio = () => {
        playBackgroundAudio();

        // Remove event listeners once audio is playing
        document.removeEventListener('click', initAudio);
        document.removeEventListener('touchstart', initAudio);
        document.removeEventListener('keydown', initAudio);
      document.removeEventListener('scroll', initAudio);
    };

    // Add event listeners for user interaction
    document.addEventListener('click', initAudio);
    document.addEventListener('touchstart', initAudio);
    document.addEventListener('keydown', initAudio);
    document.addEventListener('scroll', initAudio);

    // Try to play automatically (may be blocked by browser)
    playBackgroundAudio();
});

// Empty SoundManager to maintain compatibility with existing code
const SoundManager = {
    playHover: () => { },
    playClick: () => { },
    playSwitch: () => { }
};

// Component to include in App.js
export const BackgroundAudio = () => {
    useEffect(() => {
        // Try to play on component mount
        playBackgroundAudio();

        return () => {
            // Cleanup
            backgroundAudio.pause();
            backgroundAudio.onended = null;
        };
    }, []);

    return null; // This component doesn't render anything
};

export default SoundManager;